module.exports = __webpack_public_path__ + "images/category_lp/art_work/assessment_achievements/4_ba939ba37b95486ab062539314780652.jpg";